// extracted by mini-css-extract-plugin
export default {"business-resource-grid":"business-resource-grid--y4oAr","businessResourceGrid":"business-resource-grid--y4oAr"};